import { render, staticRenderFns } from "./EditApplicableArea.vue?vue&type=template&id=3e674020&scoped=true&"
import script from "./EditApplicableArea.vue?vue&type=script&lang=js&"
export * from "./EditApplicableArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e674020",
  null
  
)

export default component.exports